import { Observable } from 'rxjs';
import { IPreregister, IRegister } from '../models/waitlist.model';

export abstract class WaitListRepository {
    abstract postPreregister<T>(data: IPreregister): Observable<T>;
    abstract postRegister<T>(data: IRegister): Observable<T>;
}
